<template>
<div class="mt-4">
  <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
  <span>Os campos marcados com asterisco(*) são obrigatórios.</span>
</div>
</template>

<script>
export default {
  name: "RequiredFieldsWarningComponent",
}
</script>